<template>
  <div>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        v-model="solicitacoesSelecionadas"
        show-select
        item-key="solicitarItem.numeroSolicitacaoItem"
        :single-select="false"
        :headers="tableHeader"
        :items="tableRows"
        :search="search"
        :options.sync="options"
        :server-items-length='totalItens'
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>{{ tableTitle }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              @click="gerarPDF(solicitacoesSelecionadas)"
            >Gerar PDF</v-btn>
          </v-toolbar>
        </template>

        <template v-slot:[`item.solicitarItem.dataSolicitarItem`]="{ item }"> <!--- Trecho específico para tratamento do tipo tarefa --->
          {{ _formatStringInBrazilianDateFormat(item.solicitarItem.dataSolicitarItem) }}
        </template>

        <template v-slot:[`item.solicitarItem.indicadorStatusSolicitarItem`]="{ item }"> <!--- Trecho específico para tratamento do tipo tarefa --->
          {{ formataStatus(item.solicitarItem.indicadorStatusSolicitarItem) }}
        </template>

        <template v-slot:[`item.actions`]="{ item }">

          <v-tooltip v-if="item.indicadorStatus != 8 && isStatus" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                @click="emitDataTableUpdateStatusRowEvent(item)"
                v-bind="attrs"
                v-on="on"
                >mdi-flag-variant</v-icon
              >
            </template>
            <span>Atualizar Status</span>
          </v-tooltip>

          <v-tooltip v-if="isDel && item.solicitarItem.indicadorStatusSolicitarItem != 2 && item.solicitarItem.indicadorStatusSolicitarItem != 1"  bottom > 
            <template v-slot:activator="{ on, attrs }">
            <v-icon small @click="emitDataTableDeleteRowEvent(item)" v-bind="attrs"
                v-on="on">mdi-delete</v-icon>
            </template>
            <span>Excluir</span>
          </v-tooltip>

        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from "../plugins/axios";
import store from "@/store/index";

export default {
  props: {
    tableTitle: String,
    newRowmodalButtonText: String,
    tableHeader: Array,
    tableRows: Array,
    isStatus: Boolean,
    isDel: Boolean,
    totalItens: Number
  },

  watch: {
    options: {
      handler () {
        this.$emit("datatable-update-page", this.options);
      },
      deep: true
    },
    search(){
      this.$emit("datatable-update-search", this.search);
    }
  },

  data: function() {
    return {
      options: {
        itemsPerPage: 10
      },
      
      search: "",
      solicitacoesSelecionadas: [],

      config: {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": store.state.token,
        },
      },
    };
  },

  methods: {
    async gerarPDF(listItens) {
      var pdfMake = require('pdfmake/build/pdfmake.js')

      if (pdfMake.vfs == undefined){
        var pdfFonts = require('pdfmake/build/vfs_fonts.js')
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      
      var docDefinition = {
        info: {
          title: 'Relatório de Solicitações',
        },
        content: [],
        styles: {
          header: {
            fontSize: 24,
            bold: true,
            margin: [0, 0, 0, 24]
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 16, 0, 8]
          },
          table: {
            margin: [0, 16, 0, 56]
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: 'black'
          },
          subtext: {
            fontSize: 14, 
            bold: true, 
            margin: [0, 16, 0, 8]
          },
          columns: {
            columnGap: 20,
            margin: [0, 8, 0, 32]
          },
          assinatura: {
            columnGap: 20,
            margin: [0, 40, 0, 16]
          }
        },
        defaultStyle: {
          // alignment: 'justify'
        }
      }

      if(listItens.length > 0) {

        for (let solicitacao of listItens) {
            let tituloSolicitacao = { text: "Número da solicitação: "+ solicitacao.solicitarItem.numeroSolicitacaoItem+ " \n" +solicitacao.endereco.nomeEndereco, style: 'header' }
            let subtituloSolicitacao = {
              alignment: 'justify',
              style: 'columns',
              columns: [
                [
                  { text: 'Responsável pela Unidade: ', style: 'subheader' },
                  { text: solicitacao.endereco.nomeResponsavel },
                ],
                [
                  { text: 'Data da Solicitação: ', style: 'subheader' },
                  { text: this._formatStringInBrazilianDateFormat(solicitacao.solicitarItem.dataSolicitarItem) }
                ]
              ]
            }

            docDefinition.content.push(tituloSolicitacao)
            docDefinition.content.push(subtituloSolicitacao)

            let response = await axios.put("itensSolicitar", { numeroSolicitarItem: solicitacao.solicitarItem.numeroSolicitacaoItem, }, this.config);
            const listOfItensSolicitados = response.data;

            if(listOfItensSolicitados.length > 0) {
                let tabela = [
                  { text: 'Itens Solicitados de: '+ solicitacao.solicitarItem.descricaoSolicitarItem, style: 'subtext' },
                  {
                    style: 'table',
                    widths: ['*', 'auto'],
                    table: {
                      headerRows: 1,
                      body: [
                        [{text: 'ID Solicitação', style: 'tableHeader'}, {text: 'ID Item', style: 'tableHeader'}, {text: 'Nome do Item', style: 'tableHeader'}, {text: 'Quantidade Estoque', style: 'tableHeader'}, {text: 'Quantidade Solicitada', style: 'tableHeader'}],
                      ]
                    },
                    layout: 'lightHorizontalLines'
                  },
                ]

                for (let item of listOfItensSolicitados) {
                  tabela[1].table.body.push([solicitacao.solicitarItem.numeroSolicitacaoItem, item.numeroItemSistemaUnidade, item.nomeItemSistema, item.quantidadeEstoque, item.quantidadeSolicitada],)
                }

                docDefinition.content.push(tabela)

            } else {
                let itens = {text: 'Sem itens solicitados!', style: 'subtext'}
                docDefinition.content.push(itens)

            }
        }
       
      } else {
        let tituloSolicitacao = { text: 'Não foi possível gerar o relátorio, sem dados para gerar!', style: 'header' }
        docDefinition.content.push(tituloSolicitacao)
        
      }

      pdfMake.createPdf(docDefinition).open()
    },

    formataStatus(status){
      switch (status) {
        case 0: return "Aguardando Aprovação"
        case 1: return "Em processo de compras"
        case 2: return "Comprado"
        case 3: return "Recusado"
      }
    },

    _formatStringInBrazilianDateFormat(data) {
      if(data) {
        var ano  = data.split("-")[0];
        var mes  = data.split("-")[1];
        var dia  = data.split("-")[2];
        var dia2  = dia.substring(0,2)
        // Utilizo o .slice(-2) para garantir o formato com 2 digitos.
        return  ("0"+dia2).slice(-2) + '/' + ("0"+mes).slice(-2) + '/' +  ano;
      } else {
        return "Não informado!"
      }

    },

    emitDataTableUpdateStatusRowEvent(row) {
      this.$emit("datatable-updatestatusrow", row);
    },

    emitDataTableDeleteRowEvent(row){
      this.$emit("datatable-deleterow", row)
    },
  },
};
</script>
